import { render, staticRenderFns } from "./security-menu.vue?vue&type=template&id=2ec24f66&scoped=true&"
import script from "./security-menu.vue?vue&type=script&lang=js&"
export * from "./security-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec24f66",
  null
  
)

export default component.exports